<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <!-- start: PAGE TITLE -->
      <section id="page-title" style="background-color: #d1d1d1;">
        <div class="row">
          <div class="col-sm-10">
            <h1 class="mainTitle">All Lab/Scan Bookings</h1>
          </div>
          <div class="col-sm-2">
            <!-- <router-link style="margin-right: 10px" class="btn btn-primary"
              :to="{ name: 'create-labBooking' }">create</router-link> -->
            <!-- <router-link class="btn btn-success" :to="{ name: 'deleted-labBookings' }">Deleted Lab
              Bookings</router-link> -->
          </div>

        </div>
      </section>
      <!-- end: PAGE TITLE -->
      <!-- start: DYNAMIC TABLE -->
      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-12">

            <div v-if="labBookings.length > 0">
              <MyTable :columns="columns" :actions="true">
                <tr v-for="(booking, index) in labBookings" :key="index">
                  <th scope="row">{{ booking.id }}</th>
                  <td>{{ booking.name ?? 'N/A' }}</td>
                  <td>{{ booking.phone ?? 'N/A' }}</td>
                  <td>{{ booking.appointments ? booking.appointments.appointment_data?.lab_name : 'N/A' }}</td>
                  <td>{{ booking.appointments ? booking.appointments.appointment_type : 'N/A' }}</td>
                  <td>{{ booking.appointments ? booking.date : 'N/A' }}</td>
                  <td>{{ booking.appointments ? booking.appointments.appointment_day.name_en : 'N/A' }}</td>
                  <td>{{ booking.appointments ? booking.appointments.appointment_hour.from + ' - ' +
                    booking.appointments.appointment_hour.to : 'N/A' }}
                  </td>
                  <td>
                    <span :class="statusClass(booking.status ? booking.status : 'unknown')">
                      {{ booking.status ? booking.status : 'Unknown' }}
                    </span>
                  </td>

                  <td>
                    <!-- <button class="me-2 btn btn-danger" @click="deleteBooking(booking.id)">
                      Delete
                    </button> -->
                    <!-- <router-link class="btn btn-primary spacing"
                      :to="{ name: 'edit-labBooking', params: { id: booking.id } }">
                      Edit
                    </router-link> -->
                    <router-link class="badge  bg-info spacing" v-if="hasPermission('lab/scan-booking get')"
                      :to="{ name: 'show-labBooking', params: { id: booking.id } }">
                      Booking Details
                    </router-link>
                  </td>
                </tr>
              </MyTable>
            </div>
            <div v-else class="alert alert-info">
              No Bookings found.
            </div>
          </div>
        </div>
      </div>
      <!-- end: DYNAMIC TABLE -->
    </div>
  </div>
</template>

<script>
import axios from "../../Axios";
import { store } from "@/Store";
import $ from 'jquery'; // Import jQuery
import MyTable from "../MyTable//MyTable.vue"; // Import your MyTable component

export default {
  name: "AllLabBookings",
  components: {
    MyTable,
    // Paginate,
  },
  data() {
    return {
      dataTable: [], // Store DataTable instance
      labBookings: [],
      meta: {},
      searchTerm: "",
      columns: [
        { label: '#', key: 'id' },
        { label: 'Patiant Name', key: 'name' },
        { label: 'Patiant Phone', key: 'phone' },
        { label: 'Lab Name', key: 'appointments.appointment_data.lab_name' },
        { label: 'Appointment Type', key: 'appointments.appointment_type' },
        { label: 'Date', key: 'appointments.date' },
        { label: 'Day', key: 'appointments.appointment_day' },
        { label: 'Hour', key: 'appointments.appointment_hour' },
        { label: 'Status', key: 'status.name' },

      ],
    };
  },

  async created() {
    this.fetchBookings();
  },
  computed: {
    hasPermission() {
      return (permission) => store.hasPermission(permission);
    },
    filteredBookings() {
      if (!this.searchTerm) {
        return this.labBookings;
      }
      const term = this.searchTerm.toLowerCase();
      return this.labBookings.filter(
        (lab) =>
          lab.name.toLowerCase().includes(term)
      );
    },
  },

  methods: {
    // fetch labs
    async fetchBookings() {
      try {
        const response = await axios.get(
          `/admin/admin/lab-booking/all`
        );
        this.labBookings = response.data.data;
        this.meta = response.data.meta;
        this.$nextTick(() => {
          this.initializeDataTable(); // Initialize DataTable after fetching users
        });
      } catch (error) {
        console.error("Error fetching labBookings:", error);
      }
    },
    statusClass(status) {
      switch (status) {
        case 'Pending':
          return 'badge  bg-warning text-dark'; // Yellow
        case 'Confirmed':
          return 'badge  bg-primary'; // Blue
        case 'Done':
          return 'badge  bg-success'; // Green
        case 'Canceled':
          return 'badge  bg-danger'; // Red
        default:
          return 'badge  bg-secondary'; // Gray for unknown or missing
      }
    },
    initializeDataTable() {
      this.$nextTick(() => {
        $('.sample_1').DataTable(); // Initialize DataTable
      });
    },
    deleteBooking(id) {
      axios
        .delete(`/admin/admin/lab-booking/delete?id=${id}`)
        .then((response) => {
          console.log(response.data);
          this.fetchBookings();
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },

};
</script>
<style scoped>
.table {
  margin-top: 10px;
}

.spacing {
  margin-left: 10px !important;
}

.btn {
  padding: 0.5em 1em;
  border-radius: 0.25rem;
  font-size: 0.9em;
  text-align: center;
  display: inline-block;
  min-width: 100px;
}

/* Styling for the Current Status Badge */
.badge {
  display: inline-block;
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 0.9em;
  text-transform: capitalize;
}

/* Different Badge Colors Based on Status */
.badge-pending {
  background-color: #ffc107;
  color: #fff;
}

.badge-approved {
  background-color: #28a745;
  color: #fff;
}

.badge-rejected {
  background-color: #dc3545;
  color: #fff;
}

.badge-inprogress {
  background-color: #17a2b8;
  color: #fff;
}
</style>